import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion';
import { useEffect } from 'react';

export function useScrollAnim(threshold = 0.1) {
  const controls = useAnimation();
  const { ref, inView } = useInView({ triggerOnce:true, threshold });
  useEffect(() => { if (inView) controls.start('visible'); }, [inView, controls]);
  return { ref, controls, inView };
}

export const V = {
  fadeUp:    { hidden:{ opacity:0, y:55 },       visible:{ opacity:1, y:0,    transition:{ duration:0.75, ease:[0.22,1,0.36,1] } } },
  fadeLeft:  { hidden:{ opacity:0, x:-55 },      visible:{ opacity:1, x:0,    transition:{ duration:0.75, ease:[0.22,1,0.36,1] } } },
  fadeRight: { hidden:{ opacity:0, x:55 },       visible:{ opacity:1, x:0,    transition:{ duration:0.75, ease:[0.22,1,0.36,1] } } },
  scaleIn:   { hidden:{ opacity:0, scale:0.82 }, visible:{ opacity:1, scale:1, transition:{ duration:0.65, type:'spring', bounce:0.3 } } },
  stagger:   { hidden:{}, visible:{ transition:{ staggerChildren:0.1, delayChildren:0.05 } } },
  stagger2:  { hidden:{}, visible:{ transition:{ staggerChildren:0.13, delayChildren:0.1 } } },
  child:     { hidden:{ opacity:0, y:32 },       visible:{ opacity:1, y:0,    transition:{ duration:0.65, ease:[0.22,1,0.36,1] } } },
  childLeft: { hidden:{ opacity:0, x:-32 },      visible:{ opacity:1, x:0,    transition:{ duration:0.65, ease:[0.22,1,0.36,1] } } },
  childRight:{ hidden:{ opacity:0, x:32 },       visible:{ opacity:1, x:0,    transition:{ duration:0.65, ease:[0.22,1,0.36,1] } } },
};
